import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-screen-heading',
  templateUrl: './screen-heading.component.html',
  styleUrls: ['./screen-heading.component.scss']
})
export class ScreenHeadingComponent {
  @Input() title: string = '';
  @Input() debtDashboardTitle: string = '';
  @Input() isDashboardTitleVisible: boolean = false;
  @Input() isButtonsVisible: boolean = true;
  @Input() hideButtonsOnSmallScreen: boolean = true;
  @Input() hideBottomBorder: boolean = true;
  @Input() alignContentLeft: boolean = false;
  @Input() backIconVisible: boolean = false;
  @Input() isResponsive: boolean = true;
  @Input() secondTitle: string = '';
  @Output() backClicked = new EventEmitter<any>();
  @Output() showNotification: boolean = false;
  
  showNotifications(){
    this.showNotification = !this.showNotification;
  }

  closeNotification() {
    console.log("Napolju")
    if(this.showNotification){
      this.showNotification = false;
      console.log("pritisnuo ifu")
    }
  }
}
